export enum UserTypeEnum {
  Internal = 0,
  External = 1,
  None = 2
}
